import { Datagrid, FunctionField, TextField } from 'react-admin';

const getSemaphoreColor = (value?: number) => {
  if (value === null || value === undefined) return '#b3b3c4';
  if (value >= 10) return '#5fcd3d';
  if (value >= 5) return '#f8cc56';
  return '#e04036';
};

export const RecommendationDatagrid: React.FC = () => {
  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      sx={{
        '& .RaDatagrid-rowCell > *': {
          display: 'block',
          minWidth: '100%',
        },
      }}
    >
      <TextField label="Typ" sortable={false} source="type" width="6em" />
      <FunctionField
        label="Text"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        render={(record: any) => {
          return <span style={{ whiteSpace: 'pre-line' }}>{record['texts'].join('\n')}</span>;
        }}
        width="24em"
      />
      <FunctionField
        label="Semafor"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        render={(record: any) => {
          const color = getSemaphoreColor(record.score);
          return (
            <span
              style={{
                backgroundColor: color,
                borderRadius: '50%',
                display: 'inline-block',
                height: 20,
                width: 20,
              }}
            />
          );
        }}
      />
    </Datagrid>
  );
};
